import { InspectionDetails } from "../../components/properties/inspection-details";


export const PropertyInspectionsTab = ({ propertyDocument, saveProperty }) => {

    return (
        <div className="tab-pane fade" id="nav-pills-tab-inspections">
            <InspectionDetails
                containerClassName={"row mb-15px"}
                propertyDocument={propertyDocument}
                saveProperty={saveProperty}
            />
        </div>);
}